export const SITE_URL = "https://acueducto.com";
export const LEGACY_SITE_URL = "https://acueducto.studio";
export const PODCAST_URL = "https://cuandoelriosuena.com";
export const CALCULATOR_URL = "https://calculadora-ux.acueducto.com";
export const DISCOVERY_URL = "https://discovery.acueducto.com";
export const WEB_DISCOVERY_URL =
  "https://calendly.com/acueducto/discovery-con-acueducto-web/";
export const CONTACT_EMAIL = "hola@acueducto.com";
export const SUPPORT_EMAIL = "soporte@acueducto.com";

// Tracking IDs por app. Cada _app.tsx importa los suyos y los pasa al
// Layout vía props (fbPixelId / linkedInPixelId / gaId / clarityProjectId).
// Si una app no tiene un ID para un servicio, dejar el string vacío y Layout
// omite la inicialización de ese tracker.
export const STUDIO_FB_PIXEL_ID = "1434825421667114";
export const PODCAST_FB_PIXEL_ID = "26702167152756730";
export const STUDIO_LINKEDIN_PIXEL_ID = "1943114";
export const PODCAST_LINKEDIN_PIXEL_ID = "1943114";
export const STUDIO_GA_ID = "G-VEB3KBDN1C";
export const PODCAST_GA_ID = "G-ZJNMCN5Z2Z";
export const MICROSOFT_CLARITY_PROJECT_ID = "xiund8mlm2";
